/* eslint-disable camelcase */
import forEachObjIndexed from "ramda/src/forEachObjIndexed"

import { getCookie, setCookie, removeCookies } from "services/utils/cookie"
import { vkkv } from "services/utils/fn"

export function setCustomer(customerKey) {
  if (customerKey) {
    resetCustomer(customerKey)
    setCookie("customerKey", customerKey)
  }
}

export function resetCustomer(customerKey) {
  const previousCustomer = getCookie("customerKey")

  if (previousCustomer !== customerKey) {
    removeCookies(["accountNumber"])
  }
}

export function setAuthorization(response) {
  const accessToken = response.headers.access_token

  const {
    data: {
      resultData: {
        documentNumber,
        clientId,
        clientStatus,
        user,
        customerKey,
        authDate,
        customerId,
        customerCrm,
        disability_token
      } = {}
    } = {}
  } = response

  if (accessToken) {
    forEachObjIndexed(vkkv(setCookie), {
      authDate,
      clientId,
      clientStatus,
      customerKey,
      documentNumber,
      user,
      userName: user
    })
  }

  forEachObjIndexed(vkkv(setCookie), {
    customerId,
    customerCrm,
    disability_token
  })
}

export function setAuthorizationBff(response) {
  const {
    data: { access_token, refresh_token }
  } = response

  forEachObjIndexed(vkkv(setCookie), {
    Authorization: `Bearer ${access_token}`,
    refreshToken: refresh_token
  })
}

export function getAuthorizationBff() {
  return getCookie("Authorization")
}

export function getRefreshToken() {
  return getCookie("refreshToken")
}

export function getHttpHeaders() {
  return {}
}

export function getRefreshTokenRequestConfig(backendPath) {
  return {
    baseURL: backendPath,
    url: "/auth/oauth2/refresh",
    method: "POST",
    data: {
      refreshToken: getRefreshToken(),
      redirectUri: window.location.href
    }
  }
}

export function isAuthenticated() {
  return !!getAuthorizationBff()
}

export function killSession() {
  removeCookies([
    "customerKey",
    "x-id",
    "accountNumber",
    "sensedia-access-token",
    "sensedia-refresh-token",
    "sensedia-corp-access-token",
    "sensedia-corp-refresh-token",
    "authDate",
    "clientId",
    "clientStatus",
    "documentNumber",
    "user",
    "userName",
    "customerId",
    "customerCrm",
    "disability_token",
    "Authorization"
  ])

  window.localStorage.clear()
}

export function setSensediaAuthorization(response) {
  const {
    data: { access_token: accessToken, refresh_token: refreshToken }
  } = response

  if (refreshToken && accessToken) {
    forEachObjIndexed(vkkv(setCookie), {
      "sensedia-access-token":
        accessToken || getCookie("sensedia-access-token"),
      "sensedia-refresh-token":
        refreshToken || getCookie("sensedia-refresh-token")
    })
  }
}

export function getSensediaAccessToken() {
  const accessToken = getCookie("sensedia-access-token")
  const refreshToken = getCookie("sensedia-refresh-token")
  return { accessToken, refreshToken }
}

export function setSensediaCorpAuthorization(response) {
  const {
    data: {
      access_token: accessTokenCorp,
      refresh_token_corp: refreshTokenCorp
    }
  } = response

  if (refreshTokenCorp && accessTokenCorp) {
    forEachObjIndexed(vkkv(setCookie), {
      "sensedia-corp-access-token":
        accessTokenCorp || getCookie("sensedia-corp-access-token"),
      "sensedia-corp-refresh-token":
        refreshTokenCorp || getCookie("sensedia-corp-refresh-token")
    })
  }
}

export function getSensediaCorpAccessToken() {
  const accessTokenCorp = getCookie("sensedia-corp-access-token")
  const refreshTokenCorp = getCookie("sensedia-corp-refresh-token")
  return { accessTokenCorp, refreshTokenCorp }
}

export function getSensediaHttpHeaders() {
  const Authorization = getSensediaAccessToken()
  return Authorization ? { Authorization } : {}
}

export function getSensediaCorpHttpHeaders() {
  const Authorization = getSensediaCorpAccessToken()
  return Authorization ? { Authorization } : {}
}

export function getSessionHeaders() {
  return {
    customerKey: getCookie("customerKey")
  }
}



// WEBPACK FOOTER //
// ./src/services/network/auth.js